import api from "../../../utils/api";

// Get cehcklist list
export const getChecklists = async () => {
    const res = await api.get("/qa/checklists");
    return res.data;
};

//create cehcklists
export const createChecklist = async (payload) => {
    const res = await api.post("/qa/checklists", payload);
    return res.data;
};

//view checklist details
export const getCheckListByid = async (id)=>{
    const res = await api.get(`/qa/checklists/${id}`);
    return res.data;
}

//update checklist
export const updateChecklist = async(id,payload) => {
    const res = await api.put(`/qa/checklists/${id}`, payload);
    return res.data;
}

//delete checklist
export const deleteChecklists = async(id) => {
    const res =await api.delete(`/qa/checklists/${id}`);
    return res.data;
}

// Add item to checklist
export const addChecklistItem = async (checklistId, payload) => {
    const res = await api.post(`/qa/checklists/${checklistId}/items`,payload)
    return res.data;
};

// Update checklist item
export const updateChecklistItem = async (itemId, payload) => {
    const res = await api.put(`/checklist-items/${itemId}`,payload);
    return res.data;
};

// Delete checklist item
export const deleteChecklistItem = async (itemId) => {
    const res = await api.delete(`/checklist-items/${itemId}`);
    return res.data;
};